import React from "react";
import Icon from "../icon";
var ToolbarSubscriptionRequiredLink = function ToolbarSubscriptionRequiredLink(_ref) {
    var status = _ref.status, openModal = _ref.openModal, iconName = _ref.iconName, title = _ref.title, withSpotlight = _ref.withSpotlight;
    var renderIcon = function renderIcon() {
        return /*#__PURE__*/ React.createElement(Icon, {
            iconName: iconName,
            color: withSpotlight ? "#005C16" : "#ff5b00",
            className: "w-8 mb-2",
            tooltip: title
        });
    };
    var openLoginModal = function openLoginModal() {
        return openModal("LOGIN_REQUIRED");
    };
    var openSubscriptionModal = function openSubscriptionModal() {
        return openModal("SUBSCRIPTION_REQUIRED");
    };
    switch (status.status) {
        case "ERROR":
        case "LOADING":
        case "DEACTIVATED":
            return null;
        case "LOGIN_REQUIRED":
            return /*#__PURE__*/ React.createElement("button", {
                className: "block cursor-pointer",
                onClick: openLoginModal
            }, renderIcon());
        case "SUBSCRIPTION_REQUIRED":
            return /*#__PURE__*/ React.createElement("button", {
                className: "block cursor-pointer",
                onClick: openSubscriptionModal
            }, renderIcon());
    } // TODO In firefox, .mp3 links are not downloaded per default but rather played in firefox.
    return /*#__PURE__*/ React.createElement("a", {
        href: status.url,
        className: "block cursor-pointer",
        target: "_blank",
        rel: "noopener noreferrer",
        title: title
    }, renderIcon());
};
export default ToolbarSubscriptionRequiredLink;
